<template>
  <div ref="containerRef" class="vue-container-query">
    <slot />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import matchQueries from 'container-query-toolkit/lib/matchQueries'
import ResizeObserverLite from 'resize-observer-lite'

export default {
  name: 'CustomContainerQuery',
  props: {
    query: {
      type: Object,
      required: true
    },
    initialSize: {
      type: Object,
      default: null
    }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const containerRef = ref(null)
    let resizeObserver = null

    const handleChange = (params) => {
      emit('change', params)
    }

    const startObserving = () => {
      if (!containerRef.value) return

      if (resizeObserver) {
        resizeObserver.disconnect()
      }

      resizeObserver = new ResizeObserverLite((size) => {
        const result = matchQueries(props.query)(size)
        handleChange(result)
      })

      resizeObserver.observe(containerRef.value)
    }

    // 初始化
    if (props.initialSize) {
      const params = matchQueries(props.query)(props.initialSize)
      handleChange(params)
    }

    onMounted(() => {
      startObserving()
    })

    onUnmounted(() => {
      if (resizeObserver) {
        resizeObserver.disconnect()
      }
    })

    // 监听 query 变化
    watch(() => props.query, () => {
      startObserving()
    }, { deep: true })

    return {
      containerRef
    }
  }
}
</script>

<style scoped>
.vue-container-query {
  width: 100%;
  height: 100%;
}
</style>










